import { render, staticRenderFns } from "./EquipamentoPainelRelacionamento.vue?vue&type=template&id=15769a74&scoped=true&"
import script from "./EquipamentoPainelRelacionamento.vue?vue&type=script&lang=js&"
export * from "./EquipamentoPainelRelacionamento.vue?vue&type=script&lang=js&"
import style0 from "./EquipamentoPainelRelacionamento.vue?vue&type=style&index=0&id=15769a74&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15769a74",
  null
  
)

export default component.exports